import { createFileRoute } from '@tanstack/react-router'
import DocumentosDigitaisModeloEditorPage from '@/pages/dashboard/documentos-digitais-modelo-editor-page'

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/documentos-digitais/modelos/novo',
)({
  component: () => <DocumentosDigitaisModeloEditorPage mode="create" />,
})
